<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel">
      <h2>{{getPaymentName()}}</h2>
      <button class="b-btn b-btn_border_none" @click="cancel">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="col-12 b-form b-dialog__form mt-4">
      <template v-if="selectedCommandName === 'CopyPayment'">
        <CopyPaymentParameters ref="commandComponent" :assetComponent="assetComponent" :paymentParams="paymentParams" />
      </template>
      <div class="row mb-5">
        <div class="col-8">
          <div class="b-form__container">
            <div class="b-form__container_type_flex">
              <label>{{$t('CONTENT.events.select_contract_event')}}</label>
              <dynamic-icon class="mb-1 ml-1" v-tooltip="$t('CONTENT.hints.choosePaymentEvent')" icon="question"></dynamic-icon>
            </div>
            <cool-select
              :list="commands"
              option-value="name"
              option-text="displayName"
              v-model="selectedCommandName"
              :placeholder="$t('CONTENT.choose')"
              @change="selectCommand($event)"
            ></cool-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <template v-if="selectedCommandName === 'ChangeRentRate'">
            <ChangeRentRate ref="commandComponent" :paymentParams="paymentParams" />
          </template>
          <template v-if="selectedCommandName === 'IndexationRefinement'">
            <IndexationRefinement ref="commandComponent" :paymentParams="paymentParams" />
          </template>
          <template v-if="selectedCommandName === 'PaymentDeletion'">
            <PaymentDeletion ref="commandComponent" :paymentParams="paymentParams" />
          </template>
          <template v-if="selectedCommandName === 'ChangePaymentStartDate'">
            <ChangePaymentStartDate ref="commandComponent" :paymentParams="paymentParams" />
          </template>
          <template v-if="selectedCommandName === 'ChangePaymentEndDate'">
            <ChangePaymentEndDate ref="commandComponent" :paymentParams="paymentParams" />
          </template>
          <template v-if="selectedCommandName === 'ChangePaymentFrequency'">
            <ChangePaymentFrequency ref="commandComponent" :paymentParams="paymentParams" />
          </template>
          <template v-if="selectedCommandName === 'ChangeFirstPaymentDate'">
            <ChangeFirstPaymentDate ref="commandComponent" :paymentParams="paymentParams" />
          </template>
          <template v-if="selectedCommandName === 'ReclassSecurityPayment'">
            <ReclassSecurityPayment ref="commandComponent" :paymentParams="paymentParams" />
          </template>
        </div>
      </div>
      <div class="row" v-if="selectedCommandName === 'SetIndexation'">
        <div class="col-12">
          <template>
            <SetIndexation ref="commandComponent" :paymentParams="paymentParams" />
          </template>
        </div>
      </div>
      <div class="row" v-if="selectedCommandName === 'SetDiscount'">
        <div class="col-12">
          <template>
            <SetDiscount ref="commandComponent" :paymentParams="paymentParams" />
          </template>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-6">
          <div class="b-form__container b-form__container_type_flex">
            <button
              class="b-btn b-btn_type_primary"
              type="button"
              @click="save($event)"
            >{{$t('CONTENT.save')}}</button>
            <button
              class="b-btn b-btn_type_empty"
              @click.prevent="cancel"
            >{{$t('CONTENT.cancel')}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ChangeRentRate from "../../components/commands/ChangeRentRate";
import PaymentDeletion from "../../components/commands/PaymentDeletion";
import ChangePaymentFrequency from "../../components/commands/ChangePaymentFrequency";
import ChangePaymentStartDate from "../../components/commands/ChangePaymentStartDate";
import ChangePaymentEndDate from "../../components/commands/ChangePaymentEndDate";
import ChangeFirstPaymentDate from "../../components/commands/ChangeFirstPaymentDate";
import SetIndexation from "../commands/SetIndexation";
import SetDiscount from "../commands/SetDiscount";
import { mapGetters } from "vuex";
import IndexationRefinement from "../commands/IndexationRefinement";
import AddPaymentParameters from "@/plugins/eventRegistry/components/commands/AddPaymentParameters.vue";
import CopyPaymentParameters from "@/plugins/eventRegistry/components/commands/CopyPaymentParameters.vue";
import ReclassSecurityPayment from "../commands/ReclassSecurityPayment.vue";

export default {
  components: {
    ReclassSecurityPayment,
    CopyPaymentParameters,
    SetIndexation,
    ChangeRentRate,
    IndexationRefinement,
    PaymentDeletion,
    ChangePaymentEndDate,
    ChangePaymentStartDate,
    ChangePaymentFrequency,
    ChangeFirstPaymentDate,
    SetDiscount,
  },
  props: {
    paymentParams: {
      type: Object,
      required: true
    },
    assetComponent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      commands: [
        {
          displayName: this.$t("CONTENT.events.ChangeRentRate"),
          name: "ChangeRentRate"
        },
        {
          displayName: this.$t("CONTENT.events.IndexationRefinement"),
          name: "IndexationRefinement"
        },
        {
          displayName: this.$t("CONTENT.events.PaymentDeletion"),
          name: "PaymentDeletion"
        },
        {
          displayName: this.$t("CONTENT.events.CopyPayment"),
          name: "CopyPayment"
        },
        {
          displayName: this.$t("CONTENT.events.ChangePaymentStartDate"),
          name: "ChangePaymentStartDate"
        },
        {
          displayName: this.$t("CONTENT.events.ChangePaymentEndDate"),
          name: "ChangePaymentEndDate"
        },
        {
          displayName: this.$t("CONTENT.events.ChangePaymentFrequency"),
          name: "ChangePaymentFrequency"
        },
        {
          displayName: this.$t("CONTENT.events.ChangeFirstPaymentDate"),
          name: "ChangeFirstPaymentDate"
        },
        {
          displayName: this.$t("CONTENT.events.SetIndexation"),
          name: "SetIndexation"
        },
        {
          displayName: this.$t("CONTENT.events.SetDiscount"),
          name: "SetDiscount"
        },
        {
          displayName: this.$t("CONTENT.events.ReclassSecurityPayment"),
          name: "ReclassSecurityPayment"
        }
      ],
      selectedCommandName: "ChangeRentRate"
    };
  },
  computed: {
    ...mapGetters(["getPaymentNames"])
  },
  methods: {
    selectCommand(command) {
      this.selectedCommandName = command;
    },

    cancel() {
      this.$refs.commandComponent.cancel();
      this.$emit("closeModal");
    },

    save(e) {
      e.preventDefault();
      let saveResult = this.$refs.commandComponent.save();
      if (saveResult) {
        this.$emit("closeModal");
      }
    },
    getPaymentName() {
      for (let i = 0; i < this.getPaymentNames.length; i++) {
        if (
          this.getPaymentNames[i].idInDB === this.paymentParams.paymentNameId
        ) {
          return this.getPaymentNames[i].name;
        }
      }
    }
  }
};
</script>

<style>
</style>
